import {
  constants,
  type FilterChipStyleOverrides,
  type AngelouCSS,
} from "@newsela/angelou";

import { rootChipCss } from "@/search/NewSearchPageMVP/FilterPanel/FilterPanel.styles";

const neutral50 = constants.colors.ui.neutral[50];
const darkestNeutral = constants.colors.ui.neutral[700];
const hoverGrey = "rgba(234, 235, 236, 1)";

export const gradeLevelChipGroupCss: FilterChipStyleOverrides<AngelouCSS> = {
  root: {
    marginBottom: "0.5rem",
    display: "flex",
    flexWrap: "wrap",
  },
};

export const getGradeLevelChipCss = (
  isActive: boolean,
): FilterChipStyleOverrides<AngelouCSS> => ({
  root: {
    ...rootChipCss,
    backgroundColor: isActive ? darkestNeutral : neutral50,
    color: isActive ? neutral50 : darkestNeutral,

    "&:hover": {
      backgroundColor: isActive ? darkestNeutral : hoverGrey,
    },
  },
});
